import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import type { ApiClientError } from '../../../shared/api/client.js';
import { signatureApi, type SignatureDto } from '../api/signature.api.js';

export const signatureKeys = {
  mine: ['signature', 'mine'] as const,
};

/**
 * XODIMNING JORIY imzosi.
 *
 * Uzoq yashaydi (`staleTime`): imzo yiliga bir marta ham o'zgarmaydi, har
 * dialog ochilganda so'rov yuborish esa bekorga tarmoq trafigi bo'lardi.
 */
export const useMySignature = (): UseQueryResult<SignatureDto, ApiClientError> =>
  useQuery<SignatureDto, ApiClientError>({
    queryKey: signatureKeys.mine,
    queryFn: () => signatureApi.current(),
    retry: false,
    staleTime: 30 * 60_000,
  });

/**
 * Imzoni SAQLAYDI — ikki qadam bitta amalda.
 *
 * Avval rasm yuklanadi (`POST /files`), keyin u joriy imzo qilib
 * belgilanadi (`PUT /me/signature`). Ikkinchi qadam birinchisining `id` siga
 * tayanadi, shuning uchun ular ketma-ket: parallel bo'lsa, hali mavjud
 * bo'lmagan faylga havola yuborilardi.
 */
export const useSaveSignature = () => {
  const queryClient = useQueryClient();

  return useMutation<SignatureDto, ApiClientError, File>({
    mutationFn: async (file) => {
      const uploaded = await signatureApi.upload(file);
      return signatureApi.set(uploaded.id);
    },
    onSuccess: (data) => {
      // Javobning O'ZI yangi holat — qayta so'rov yuborilmaydi.
      queryClient.setQueryData(signatureKeys.mine, data);
    },
  });
};
